<template>
  <div>
    <div class="navbar-div">
      <NavbarComponent
        :colorTheme="colorTheme"
        :user="userInfo"
        analysis="PROFILE"
        @eventOnUserColorTheme="onUserColorTheme"
      />
    </div>
    <div class="ccontainer">
      <div v-if="!showLoggingIn">
        <div class="form-container p-4">
          <!-- Progress Bar -->
          <div v-if="isActive" class="progress-bar-container mb-4">
            <div class="progress" style="height: 25px;">
              <div
                class="progress-bar"
                role="progressbar"
                :style="{ width: progressWidth + '%' }"
                :aria-valuenow="progressWidth"
                aria-valuemin="0"
                aria-valuemax="100"
              >
                {{ currentPage }} of 4
              </div>
            </div>
          </div>

          <!-- Wrapper for form content and arrows -->
          <div class="form-wrapper">
            <!-- Section Title -->
            <h2 class="section-title">
              {{
                currentPage === 1
                  ? ""
                  : currentPage === 2
                  ? "Personal Information"
                  : currentPage === 3
                  ? "Company Information"
                  : "Additional Information & Password"
              }}
            </h2>

            <!-- Left Arrow -->
            <div
              class="nav-arrow left-arrow"
              v-if="currentPage > 1"
              @click="previousPage"
            >
              <span><i class="fa fa-chevron-left"></i></span>
            </div>

            <!-- Form Content -->
            <div v-if="!valiUpdate" class="form-grid">
              <!-- Page 1: Welcome Page -->
              <div v-if="currentPage === 1" class="welcome-content">
                <img
                  src="@/assets/images/symbol_white.svg"
                  alt="Company Logo"
                  class="company-logo"
                  style="max-height: 4rem"
                />
                <h1 v-if="isActive" style="color: white">
                  Thank you for choosing Quanspire
                </h1>
                <h1 v-if="!isActive" style="color: white">
                  Your account is inactive
                </h1>
                <p v-if="isActive" class="welcome-text">
                  Get started by providing your information to personalize your
                  Quanspire experience
                </p>
                <p v-if="!isActive" class="welcome-text">
                  Please contact the Quanspire team to activate your account
                </p>
              </div>

              <!-- Page 2: Personal Information -->
              <div v-if="currentPage === 2" class="form-content">
                <div class="form-row">
                  <div class="form-group">
                    <label for="first_name">First Name:</label>
                    <input
                      id="first_name"
                      type="text"
                      v-model="DataUser.first_name"
                      class="form-control"
                      placeholder="Enter first name"
                    />
                  </div>
                  <div class="form-group">
                    <label for="last_name">Last Name:</label>
                    <input
                      id="last_name"
                      type="text"
                      v-model="DataUser.last_name"
                      class="form-control"
                      placeholder="Enter last name"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label for="username">Username:</label>
                    <input
                      id="username"
                      type="text"
                      v-model="DataUser.username"
                      class="form-control disabled"
                      placeholder="Enter username"
                    />
                  </div>
                  <div class="form-group">
                    <label for="email">Email:</label>
                    <input
                      id="email"
                      type="email"
                      v-model="DataUser.email"
                      class="form-control disabled"
                      placeholder="Enter email"
                    />
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label for="phone">Phone:</label>
                    <input
                      id="phone"
                      type="text"
                      v-model="DataUser.phone"
                      class="form-control"
                      placeholder="Enter phone number"
                    />
                    <span class="text-danger small" v-if="phoneError">{{
                      phoneError
                    }}</span>
                  </div>
                  <div class="form-group">
                    <label for="country">Country:</label>
                    <select
                      id="country"
                      v-model="DataUser.Country"
                      class="form-control"
                    >
                      <option
                        v-for="(value, key) in country"
                        :key="key"
                        :value="value.id"
                      >
                        {{ value.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label for="city">City:</label>
                    <input
                      id="city"
                      type="text"
                      v-model="DataUser.city"
                      class="form-control"
                      placeholder="Enter city"
                    />
                  </div>
                  <div class="form-group">
                    <label for="address">Address:</label>
                    <input
                      id="address"
                      type="text"
                      v-model="DataUser.address"
                      class="form-control"
                      placeholder="Enter address"
                    />
                  </div>
                </div>
              </div>

              <!-- Page 3: Company Information -->
              <div v-if="currentPage === 3" class="form-content">
                <div class="form-row">
                  <div class="form-group">
                    <label for="company">Company:</label>
                    <input
                      id="company"
                      type="text"
                      v-model="DataUser.company"
                      class="form-control"
                      placeholder="Enter company"
                    />
                  </div>
                  <div class="form-group">
                    <label for="role">Role:</label>
                    <select
                      id="role"
                      v-model="DataUser.role"
                      class="form-control"
                    >
                      <option
                        v-for="(value, key) in roles"
                        :key="key"
                        :value="value.id"
                      >
                        {{ value.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label for="web_page">Web Page:</label>
                    <input
                      id="web_page"
                      type="text"
                      v-model="DataUser.web_page"
                      class="form-control"
                      placeholder="Enter web page"
                    />
                    <span class="text-danger small" v-if="webPageError">{{
                      webPageError
                    }}</span>
                  </div>
                  <div class="form-group">
                    <label for="sector">Sector:</label>
                    <select
                      id="sector"
                      v-model="DataUser.sector"
                      class="form-control"
                    >
                      <option
                        v-for="(value, key) in sector"
                        :key="key"
                        :value="value.id"
                      >
                        {{ value.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="form-row">
                  <div class="form-group">
                    <label for="ventas">Sales:</label>
                    <select
                      id="ventas"
                      v-model="DataUser.Ventas"
                      class="form-control"
                    >
                      <option
                        v-for="(value, key) in ventas"
                        :key="key"
                        :value="value.id"
                      >
                        {{ value.name }}
                      </option>
                    </select>
                  </div>
                  <div class="form-group"></div>
                </div>
              </div>

              <!-- Page 4: Additional Info & Password -->
              <div v-if="currentPage === 4" class="form-content">
                <!-- Exposure Section -->
                <div class="form-section">
                  <div class="form-row">
                    <div class="form-group">
                      <label for="foreign_currency_exposure"
                        >Foreign Currency Exposure:</label
                      >
                      <select
                        id="foreign_currency_exposure"
                        v-model="DataUser.foreign_currency_exposure"
                        class="form-control"
                      >
                        <option
                          v-for="(value, key) in listForeign"
                          :key="key"
                          :value="value.id"
                        >
                          {{ value.name }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group" v-if="validateForeign">
                      <label for="type_foreign_currency_exposure"
                        >Type Foreign Currency:</label
                      >
                      <select
                        id="type_foreign_currency_exposure"
                        v-model="DataUser.type_foreign_currency_exposure"
                        class="form-control"
                      >
                        <option value="">Select...</option>
                        <option
                          v-for="(value, key) in typeForeign"
                          :key="key"
                          :value="value.id"
                        >
                          {{ value.name }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group">
                      <label for="commodity_exposure"
                        >Commodity Exposure:</label
                      >
                      <select
                        id="commodity_exposure"
                        v-model="DataUser.commodity_exposure"
                        class="form-control"
                      >
                        <option
                          v-for="(value, key) in listCommodity"
                          :key="key"
                          :value="value.id"
                        >
                          {{ value.name }}
                        </option>
                      </select>
                    </div>
                    <div class="form-group" v-if="validateCommodity">
                      <label for="type_commodity_exposure"
                        >Type Commodity Exposure:</label
                      >
                      <select
                        id="type_commodity_exposure"
                        v-model="DataUser.type_commodity_exposure"
                        class="form-control"
                      >
                        <option value="">Select...</option>
                        <option
                          v-for="(value, key) in typeCommodity"
                          :key="key"
                          :value="value.id"
                        >
                          {{ value.name }}
                        </option>
                      </select>
                    </div>
                  </div>
                </div>

                <!-- Privacy Policy Section -->
                <div class="form-section">
                  <div class="form-row">
                    <div class="checkbox-wrapper">
                      <input
                        type="checkbox"
                        v-model="DataUser.habeas_data"
                        id="habeas_data"
                        class="custom-checkbox"
                      />
                      <label style="margin-left: 5%;" for="habeas_data">
                        Accept
                        <a @click.prevent="HabeasPage" href="#"
                          >Privacy Policy</a
                        >:
                      </label>
                    </div>
                    <span class="text-danger small" v-if="validateHabeasData">{{
                      validateHabeasData
                    }}</span>
                  </div>
                </div>

                <!-- Password Change Section -->
                <!--
                  <div class="form-section">
                    <div class="form-row">
                      <div class="form-group full-width">
                        <label>Change Password:</label>
                        <input type="checkbox" v-model="checkpassword" />
                      </div>
                    </div>
                    <div v-if="checkpassword" class="form-row">
                      <div class="form-group">
                        <label for="password_old">Old Password:</label>
                        <input
                          id="password_old"
                          type="password"
                          v-model="DataUser.password_old"
                          class="form-control"
                          placeholder="Enter old password"
                        />
                      </div>
                      <div class="form-group">
                        <label for="password_new">New Password:</label>
                        <input
                          id="password_new"
                          type="password"
                          v-model="DataUser.password_new"
                          class="form-control"
                          placeholder="Enter new password"
                        />
                        <span class="text-danger small" v-if="validatePasswrodOld">{{ validatePasswrodOld }}</span>
                      </div>
                    </div>
                    <div v-if="checkpassword" class="form-row">
                      <div class="form-group">
                        <label for="password_new_confirm">Confirm Password:</label>
                        <input
                          id="password_new_confirm"
                          type="password"
                          v-model="DataUser.password_new_confirm"
                          class="form-control"
                          placeholder="Confirm new password"
                        />
                        <span class="text-danger small" v-if="validatePasswrodNew">{{ validatePasswrodNew }}</span>
                      </div>
                      <div class="form-group"></div>
                    </div>
                    <div v-if="checkpassword" class="form-row">
                      <div class="form-group full-width">
                        <ul class="small text-muted">
                          <li>Your password can't be too similar to your other personal information.</li>
                          <li>Your password must contain at least 8 characters.</li>
                          <li>Your password can't be a commonly used password.</li>
                          <li>Your password can't be entirely numeric.</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  -->
              </div>
            </div>

            <!-- Right Arrow -->
            <div
              class="nav-arrow right-arrow"
              v-if="isActive && currentPage < 4"
              @click="nextPage"
            >
              <span><i class="fa fa-chevron-right"></i></span>
            </div>

            <!-- Update Message -->
            <div v-if="valiUpdate" class="text-center mt-3">{{ message }}</div>
          </div>

          <!-- Save Action -->
          <div v-if="currentPage === 4" class="save-action">
            <button
              class="btn btn-sm btn-primary"
              style="color: white"
              @click="saveUser"
            >
              <span v-if="showLoggingIn" class="me-2">
                <v-progress-circular
                  indeterminate
                  :size="18"
                  :width="2.5"
                  color="white"
                />
              </span>
              Save
            </button>
          </div>
        </div>
      </div>
      <div v-if="showLoggingIn">
        <div class="form-container p-4">
          <div
            class="loading-container"
            style="display: flex;
                          justify-content: center;
                          align-items: center;
                          height: 100%;
                          flex-direction: column;"
          >
            <div class="loading-icon">
              <QSLoading
                :isLoading="true"
                :size="35"
                :colorTheme="colorTheme"
              />
            </div>
            <p class="welcome-text">
              {{ message }}
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import NavbarComponent from "../components/Navbar.vue";
import QSLoading from "@/components/QSLoading.vue";
import router from "../router";
import { apiService } from "@/_services";
import { User } from "@/_core/data/User";
import { colorThemeChange, colorThemeVuex } from "@/_core/_helpers/_helpers";
import { saveUserPreferences } from "@/_core/data/SaveToDB";

export default {
  name: "EditUser",
  components: { NavbarComponent, QSLoading },
  data() {
    return {
      currentPage: 1,
      backgroundImg: require("@/assets/images/PTTSymmetryOscura02.jpg"),
      colorTheme: true, // true = dark, else light
      overview_preferences: {},
      DataUser: {
        pk_idusers: "",
        first_name: "",
        last_name: "",
        username: "",
        email: "",
        phone: "",
        Country: "",
        city: "",
        address: "",
        company: "",
        role: "",
        web_page: "",
        sector: "",
        Ventas: "",
        foreign_currency_exposure: "",
        type_foreign_currency_exposure: "",
        commodity_exposure: "",
        type_commodity_exposure: "",
        habeas_data: false,
        password_old: "",
        password_new: "",
        password_new_confirm: "",
        user_avatar: "",
      },
      userInfo: {},
      message: "",
      checkpassword: false,
      valiPhone: false,
      valiWebPage: false,
      valiPasswordOld: false,
      valiPasswordNew: false,
      valiUpdate: false,
      showLoggingIn: false,
      listForeign: [
        { id: 1, name: "Yes" },
        { id: 2, name: "No" },
      ],
      listCommodity: [
        { id: 1, name: "Yes" },
        { id: 2, name: "No" },
      ],
      roles: {},
      sector: {},
      ventas: {},
      country: {},
      typeForeign: [
        { id: 1, name: "Exporter" },
        { id: 2, name: "Importer" },
        { id: 3, name: "Both" },
      ],
      typeCommodity: [
        { id: 1, name: "Producer" },
        { id: 2, name: "Consumer" },
        { id: 3, name: "Both" },
      ],
      processed_user: null,
      root: document.documentElement,
      isActive: true,
    };
  },
  created() {
    if (!this.$store.state.user.all.items.is_active) {
      this.isActive = false;
    }
    this.initializePreferences();
    this.loadUserData();
    this.getTerms();
  },
  computed: {
    progressWidth() {
      return (this.currentPage / 4) * 100; // Calculate progress percentage for 4 pages
    },
    validatePhone() {
      const phone = this.DataUser.phone;
      const regex = /^([0-9])*$/;
      if (phone && !regex.test(phone)) {
        // this.valiPhone = true;
        // return "Format of the phone field is not correct";
        return true;
      }
      // this.valiPhone = false;
      // return null;
      return false;
    },
    validateWebPage() {
      const web_page = this.DataUser.web_page;
      const regex = /^((ftp|http|https):\/\/)?(www.)?(?!.*(ftp|http|https|www.))[a-zA-Z0-9_-]+(\.[a-zA-Z]+)+((\/)[\w#]+)*(\/\w+\?[a-zA-Z0-9_]+=\w+(&[a-zA-Z0-9_]+=\w+)*)?$/gm;
      if (web_page && !regex.test(web_page)) {
        // this.valiWebPage = true;
        // return "Format of the web page field is not correct";
        return true;
      }
      // this.valiWebPage = false;
      // return null;
      return false;
    },
    validateHabeasData() {
      return !this.DataUser.habeas_data
        ? "You must agree to our Privacy Policy"
        : null;
    },
    validatePasswrodOld() {
      const { password_old, password_new } = this.DataUser;
      if (password_old && password_new && password_old === password_new) {
        // this.valiPasswordOld = true;
        // return "The new password cannot be the same as the old password";
        return true;
      }
      // this.valiPasswordOld = false;
      // return null;
      return false;
    },
    validatePasswrodNew() {
      const { password_new, password_new_confirm } = this.DataUser;
      const expr = /^(?=.*[a-zA-Z])(?=.*\d)[a-zA-Z\d\W]{8,}$/;
      if (password_new && password_new_confirm) {
        if (password_new !== password_new_confirm) {
          // this.valiPasswordNew = true;
          // return "The new password does not match";
          return true;
        }
        if (!expr.test(password_new)) {
          // this.valiPasswordNew = true;
          // return "Your password requires a minimum of 8 characters with letters and numbers";
          return true;
        }
      }
      // this.valiPasswordNew = false;
      // return null;
      return false;
    },
    validateForeign() {
      return this.DataUser.foreign_currency_exposure === 1;
    },
    validateCommodity() {
      return this.DataUser.commodity_exposure === 1;
    },
  },
  watch: {
    "DataUser.habeas_data"(newValue) {
      this.DataUser.habeas_data = newValue ? 1 : 0;
    },
    checkpassword(val) {
      this.valiPasswordOld = val;
      this.valiPasswordNew = val;
    },
  },
  methods: {
    nextPage() {
      if (this.currentPage < 4) this.currentPage++;
    },
    previousPage() {
      if (this.currentPage > 1) this.currentPage--;
    },
    initializePreferences() {
      this.overview_preferences =
        this.$store.state.user_preferences.all.items.overview_choices || {};
      this.colorTheme = this.overview_preferences.color_theme ?? true;
      if (!this.colorTheme) {
        this.backgroundImg = require("@/assets/images/PTTSymmetryClara01.jpg");
        colorThemeChange(this.root, this.colorTheme);
      }
    },
    loadUserData() {
      this.processed_user = new User(this);
      this.userInfo = this.$store.state.user.all.items;
      Object.assign(this.DataUser, this.userInfo, {
        habeas_data: this.userInfo.habeas_data ? 1 : 0,
      });
    },
    onUserColorTheme(val) {
      this.colorTheme = val;
      this.backgroundImg = val
        ? require("@/assets/images/PTTSymmetryOscura02.jpg")
        : require("@/assets/images/PTTSymmetryClara01.jpg");
      this.overview_preferences.color_theme = val;
      colorThemeChange(this.root, val);
      colorThemeVuex(this, val);
      saveUserPreferences(this);
    },
    getTerms() {
      const params = {
        method: "GET",
        endpoint: "catalogs_profile",
        query_params: { format: "json", descriptions: "" },
      };
      apiService.getAll(params).then((data) => {
        if (data?.[0]) {
          const element = data[0];
          this.roles = element["RoleEditProfile"].RoleEditProfile;
          this.sector = element["SectorEditProfile"].SectorEditProfile;
          this.ventas = element["SalesEditProfile"].SalesEditProfile;
          this.country = element["CountryEditProfile"].CountryEditProfile;
          this.listCommodity = element["SelectEditProfile"].SelectEditProfile;
          this.listForeign = element["SelectEditProfile"].SelectEditProfile;
          this.typeForeign =
            element["TypeForeingEditProfile"].TypeForeingEditProfile;
          this.typeCommodity =
            element["TypeCommodityEditProfile"].TypeCommodityEditProfile;
        }
      });
    },
    HabeasPage() {
      window.open("/Habeas", "_blank");
    },
    userUpdateData() {
      Object.assign(this.userInfo, this.DataUser);
    },
    saveUser() {
      this.showLoggingIn = true;
      this.message = "";
      if (
        !this.valiPasswordOld &&
        !this.valiPasswordNew &&
        this.DataUser.habeas_data &&
        !this.valiWebPage &&
        !this.valiPhone
      ) {
        apiService.editUser(this.DataUser).then((data) => {
          this.valiUpdate = true;
          if (data.responser === "Succesfully updated user") {
            this.userUpdateData();
            this.message = "Your information has been updated correctly";
            this.processed_user.onLoadData();
            setTimeout(() => {
              this.message = "redirecting...";
              setTimeout(() => router.push("/Profile"), 1000);
            }, 1000);
          } else {
            this.message =
              "An error occurred while trying to update your information";
            setTimeout(() => {
              this.showLoggingIn = false;
            }, 1000);
          }
        });
      } else {
        this.showLoggingIn = false;
      }
    },
  },
};
</script>

<style scoped>
/* Main container */
.ccontainer {
  display: flex;
  justify-content: center; /* Center horizontally */
  align-items: center; /* Center vertically */
  height: calc(100vh - 56px); /* Adjust based on navbar height */
  width: 100%;
  box-sizing: border-box;
  padding: 20px; /* Optional: Add padding to ensure space around edges */
}

/* Form container */
.form-container {
  background: black;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  width: 800px; /* Fixed width */
  height: 600px; /* Fixed height */
  padding: 20px;
  position: relative;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
}

/* Form wrapper for content and arrows */
.form-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-grow: 1; /* Take available space */
  overflow: auto; /* Allow scrolling if content overflows */
}

/* Section titles */
.section-title {
  color: white;
  font-size: 2rem;
  text-align: center;
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  margin: 10px 0;
}

/* Navigation arrows */
.nav-arrow {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  width: 3%;
  height: 100%;
  background-color: transparent;
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 1.5rem;
  border: none;
  z-index: 10;
  transition: background-color 0.3s ease;
}

.nav-arrow:hover {
  background-color: rgba(255, 255, 255, 0.2);
}

.left-arrow {
  left: 5px;
}

.right-arrow {
  right: 5px;
}

/* Form grid layout */
.form-grid {
  display: flex;
  flex-direction: column;
  gap: 20px;
  width: 90%;
  min-height: 100%; /* Ensure it takes full height for centering */
  justify-content: center; /* Center content vertically */
}

/* Form content */
.form-content {
  padding-top: 50px; /* Space for fixed section title */
}

/* Welcome page specific styles */
.welcome-content {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  height: 100%;
  gap: 3rem;
  line-height: inherit;
}

.welcome-text {
  color: white;
  font-size: 1.5rem;
  text-align: center;
  max-width: 80%;
  font-weight: 100;
}

/* Form sections */
.form-section {
  padding-bottom: 20px;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);
  margin-bottom: 20px;
}

/* Form rows */
.form-row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 20px;
}

.form-group {
  display: flex;
  flex-direction: column;
}

.form-group.full-width {
  grid-column: span 2;
}

/* Input and select fields */
.form-group label {
  font-size: 1rem;
  margin-bottom: 5px;
  color: white;
}

.form-group input {
  height: 40px;
  font-size: 1.2rem;
  padding: 10px 10px 5px 10px;
  background-color: black;
  color: white;
  border: none;
  border-bottom: 1px solid white;
  outline: none;
  width: 100%;
  line-height: 1.2;
  cursor: text;
}

.form-group select {
  height: 40px;
  font-size: 1.2rem;
  padding: 10px 30px 5px 10px;
  background-color: black;
  color: white;
  border: none;
  border-bottom: 1px solid white;
  outline: none;
  width: 100%;
  line-height: 1.2;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background-image: none;
  position: relative;
  cursor: pointer;
}

/* Custom arrow for select */
.form-group select::after {
  content: "";
  position: absolute;
  right: 10px;
  top: 50%;
  transform: translateY(-50%);
  width: 0;
  height: 0;
  border-left: 5px solid transparent;
  border-right: 5px solid transparent;
  border-top: 5px solid white;
  pointer-events: none;
}

/* Custom focus state */
.form-group input:focus,
.form-group select:focus {
  border-bottom: 1px solid #3d78f7;
}

/* Style for buttons */
.btn-primary {
  background-color: #1345f2;
  border-color: #1345f2;
  padding: 10px 20px;
  font-size: 1.1rem;
}

.btn-secondary {
  background-color: #6c757d;
  border-color: #6c757d;
  padding: 10px 20px;
  font-size: 1.1rem;
}

.text-danger {
  color: #dc3545;
}

.circle-profile-div {
  background-color: #007bff;
  color: white;
  border-radius: 50%;
  width: 40px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: bold;
}

.progress {
  background-color: #202122;
}

/* Progress Bar Styling */
.progress-bar-container {
  width: 100%;
}

.progress-bar {
  background-color: #1345f2;
  color: white;
  text-align: center;
}

/* Save Action */
.save-action {
  position: absolute;
  bottom: 20px;
  right: 20px;
}

.btn-sm {
  margin: 0 5px;
}

/* Responsive design for smaller screens */
@media (max-width: 768px) {
  .form-container {
    width: 100%;
    height: auto; /* Allow height to adjust on small screens */
    min-height: 600px;
  }

  .form-row {
    grid-template-columns: 1fr;
  }

  .form-group.full-width {
    grid-column: span 1;
  }

  .nav-arrow {
    display: none;
  }

  .save-action {
    position: static;
    text-align: center;
    margin-top: 20px;
  }

  .section-title {
    position: static;
    margin: 10px 0;
  }

  .form-content {
    padding-top: 0;
  }

  .welcome-text {
    font-size: 1.2rem;
  }

  .loading-icon {
    display: flex;
    justify-content: center;
    max-height: 20%;
  }

  .loading-container {
    display: flex;
    justify-content: center; /* Horizontal centering */
    align-items: center; /* Vertical centering */
    height: 100%; /* Ensure the container takes full height */
  }
}
</style>
